import React from 'react';
import styles from './styles.scoped.css';
import PropsTypes from 'prop-types';
import { Modal } from '@mantine/core';
import Button from '../../components/elements/Button';
import IconClose from '../../components/icons/IconClose';
import NotificationExampleImage from '../../assets/contoh-notifikasi.png';
import parse from 'html-react-parser';
import dompurify from 'dompurify';

const ModalPreview = ({
  data,
  modalNotifExample, setModalNotifExample, showPreviewNotification, setShowPreviewNotification
}) => {
  return(
    <>
      <Modal centered opened={modalNotifExample} size={'auto'} withCloseButton={false}>
        <div className={styles['modal-wrapper']}>
          <h4>Contoh Tampilan Notifikasi</h4>
          <img alt="contoh notifikasi" src={NotificationExampleImage} />
          <Button
            className={styles['btn-close-modal']}
            onClick={() => setModalNotifExample(false)}
            style={'blue'}>Tutup</Button>
        </div>
      </Modal>
      <Modal centered opened={showPreviewNotification.isShow} size={'auto'} withCloseButton={false}>
        <div className={styles['modal-wrapper']}>
          <div className={styles['label']}>Preview Tampilan</div>
          {(showPreviewNotification.payload.type === '1' || showPreviewNotification.payload.type === '2') && (
            <div className={styles['preview-wrapper']}>
              <div className={styles['content']}>
                {showPreviewNotification.payload.type === '1'&& (
                  <img
                    className={styles['content-image-text']}
                    height={176}
                    src={showPreviewNotification.payload.banner
                      ? showPreviewNotification.payload.banner : data.banner}
                    width={314}
                  />
                )}
                <div className={styles['preview-content']}>
                  <h3>{dompurify.sanitize(showPreviewNotification.payload.title) || '-'}</h3>
                  <p className={showPreviewNotification.payload.type === '1' && styles['content-with-image']}>
                    {showPreviewNotification.payload.type === '1' ?
                      parse(dompurify.sanitize(showPreviewNotification.payload.description) || '-')
                      : parse(dompurify.sanitize(showPreviewNotification.payload.content) || '-')}
                  </p>
                </div>
                <Button className={styles['btn-rincian']} style={'blue'}>Lihat Rincian</Button>
              </div>

              <div className={styles['close']}>
                <IconClose type={'solid'}/>
              </div>
            </div>
          )}

          {showPreviewNotification.payload.type === '3' && (
            <div className={styles['image-wrapper']}>
              <div className={styles['content-wrapper']}>
                <span className={styles.primaryImage}>Gambar Utama</span>
                <div className={styles['content']} >
                  <img
                    className={styles['content-image']}
                    height={500}
                    src={showPreviewNotification.payload.contentImage
                      ? showPreviewNotification.payload.contentImage
                      : data.imageContent}
                    width={300}/>
                  <div className={styles['close']}>
                    <IconClose type={'solid'}/>
                  </div>
                </div>
              </div>
              <div className={styles['content-wrapper']}>
                <span>Gambar Banner</span>
                <div className={styles['content']} >
                  <img
                    className={styles['content-banner']}
                    height={176}
                    src={showPreviewNotification.payload.banner
                      ? showPreviewNotification.payload.banner : data.banner}
                    width={314}/>
                </div>
              </div>
            </div>
          )}
          <Button
            className={styles['btn-close-modal']}
            onClick={() => setShowPreviewNotification({ isShow: false, payload: {} })}
            style={'blue'}>Tutup</Button>
        </div>
      </Modal>
    </>
  );
};

export default ModalPreview;

ModalPreview.propTypes = {
  data: PropsTypes.object,
  modalNotifExample: PropsTypes.bool,
  setModalNotifExample: PropsTypes.func,
  setShowPreviewNotification: PropsTypes.func,
  showPreviewNotification: PropsTypes.object,
};
